import type { StatusPillTone } from '@/components/ui/status-pill-select';
import type { CandidateStatus, GdprStatus } from '@/types/candidates';

export const CANDIDATE_STATUS_TONE: Record<CandidateStatus, StatusPillTone> = {
  ACTIVE: 'success',
  HIRING: 'warning',
  HIRED: 'info',
  ARCHIVED: 'neutral',
};

// Bold `.es-*` palette for light theme (solid teal/amber/red on cream),
// matching the employee profile hero card. `.dark .es-*` in globals.css
// keeps the soft tinted look in dark theme.
export const GDPR_COLORS: Record<GdprStatus, string> = {
  APPROVED: 'es-active border-transparent',
  PENDING: 'es-probation border-transparent',
  EXPIRED: 'es-terminated border-transparent',
  REVOKED: 'es-terminated border-transparent',
};

export function formatStatusLabel(status: CandidateStatus): string {
  return status.charAt(0) + status.slice(1).toLowerCase();
}

export function formatGdprLabel(status: GdprStatus): string {
  return status.charAt(0) + status.slice(1).toLowerCase();
}
